import {
    buildConfigSlice,
    useConfigSlice,
    WidgetConfigSliceActionPayloadType,
} from 'widgets/store/configuration/configSlice';
import { WidgetType } from 'widgets/WidgetType';
import {
    CorporateActionsCapsuleConfigState,
    initialCorporateActionsCapsuleConfigState,
} from 'widgets/corpActions/capsule/store/CorporateActionsCapsuleConfigState';
import { selectCorporateActionsCapsuleState } from 'widgets/corpActions/capsule/store/selectors';

export const buildCorporateActionsCapsuleConfigSlice = () =>
    buildConfigSlice<CorporateActionsCapsuleConfigState>(
        WidgetType.CORPORATE_ACTIONS_CAPSULE,
        selectCorporateActionsCapsuleState,
        initialCorporateActionsCapsuleConfigState
    );

export const useCorporateActionsCapsuleConfigSlice = () =>
    useConfigSlice(buildCorporateActionsCapsuleConfigSlice());

export type CorporateActionsCapsuleConfigPayloadType =
    WidgetConfigSliceActionPayloadType<CorporateActionsCapsuleConfigState>;
